export default __webpack_public_path__ + "static/Waste-Connections-RMO-f82b4fb8856804f1687b0a2e4e7ee29c.webp";